import {
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    Popover,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";

import { TOption } from "../../../../../models";

type filterPopover = {
    usersId?: string[];
};

interface IFilterFormValues {
    usersId: string[];
}

type FilterPoppoverProps = {
    anchorEl: HTMLElement | null;
    users: TOption[];
    selectedUsers: string[];
    handleClose: () => void;
    handleSetPopoverData: (data?: string[]) => void;
};

const titleCheckBoxLabelStyle = {
    color: " rgba(62, 55, 78, 0.60)",
    fontFamily: "Noto Sans",
    fontSize: "0.875rem",
    fontStyle: " normal",
    fontWeight: 600,
    lineHeight: "1.5rem",
    letterSpacing: "0.07rem",
    textTransform: "uppercase",
};

function FilterPopover({
    anchorEl,
    users,
    selectedUsers,
    handleClose,
    handleSetPopoverData,
}: FilterPoppoverProps) {
    const [filterText, setFilterText] = useState("");
    const { control, handleSubmit } = useForm<IFilterFormValues>({
        defaultValues: {
            usersId: selectedUsers ?? [],
        },
    });
    const onSubmit = (data: IFilterFormValues) => {
        const params: filterPopover = {
            usersId: data.usersId,
        };
        handleSetPopoverData(params.usersId);
        handleClose();
    };

    const filteredOptionsUsers = users.filter((user) =>
        user.label.toLowerCase().startsWith(filterText.toLowerCase())
    );

    const open = Boolean(anchorEl);
    return (
        <Popover
            id={"filter-popover"}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
            <form
                onSubmit={handleSubmit(onSubmit)}
                style={{ padding: "1.5rem" }}
            >
                <Stack
                    sx={{
                        gap: "1.5rem",
                    }}
                >
                    <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        placeholder="Digite para filtrar..."
                        value={filterText}
                        onChange={(e) => setFilterText(e.target.value)}
                    />
                    <Box
                        sx={{
                            display: "flex",
                            gap: "2.125rem",
                            maxHeight: "30.125rem",
                            overflowY: "auto",
                        }}
                    >
                        <Stack
                            sx={{
                                width: "100%",
                                maxWidth: "16.25rem",
                            }}
                        >
                            <Typography
                                variant="button"
                                sx={titleCheckBoxLabelStyle}
                            >
                                Time
                            </Typography>
                            {filteredOptionsUsers.map((user) => (
                                <Controller
                                    key={user.value}
                                    name="usersId"
                                    control={control}
                                    render={({ field }) => (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={field.value.includes(
                                                        user.value
                                                    )}
                                                    onChange={(e) =>
                                                        field.onChange(
                                                            e.target.checked
                                                                ? [
                                                                      ...field.value,
                                                                      user.value,
                                                                  ]
                                                                : field.value.filter(
                                                                      (item) =>
                                                                          item !==
                                                                          user.value
                                                                  )
                                                        )
                                                    }
                                                />
                                            }
                                            label={user.label}
                                        />
                                    )}
                                />
                            ))}
                        </Stack>
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "1rem",
                        }}
                    >
                        <Button onClick={handleClose} color="secondary">
                            Voltar
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                        >
                            Filtrar
                        </Button>
                    </Box>
                </Stack>
            </form>
        </Popover>
    );
}

export default FilterPopover;
